<div class="summary-block flex flex-col gap-3">
  <h2 class="report-fill-heading m-0 text-lg font-semibold text-gray-900 dark:text-gray-100">
    {{ 'reports.fill.sectionSummary' | translate }}
  </h2>

  @if (loading) {
    <div
      class="summary-skeleton border border-gray-200 bg-white rounded-xl shadow-sm p-4 flex flex-col gap-3 dark:border-gray-700 dark:bg-slate-900/80"
    >
      <p-skeleton width="100%" height="2.25rem" />
      <p-skeleton width="100%" height="2.25rem" />
      <p-skeleton width="100%" height="2.25rem" />
      <div class="summary-skeleton-total flex items-center gap-2 pt-2">
        <p-skeleton width="6rem" height="1rem" />
        <p-skeleton width="5rem" height="1rem" />
      </div>
    </div>
  } @else {
    <div
      class="summary-table-card border border-gray-200 bg-white rounded-xl shadow-sm overflow-hidden dark:border-gray-700 dark:bg-slate-900/80"
    >
      <p-table
        [value]="rows"
        styleClass="p-datatable-sm p-datatable-gridlines summary-table"
        [resizableColumns]="true"
        columnResizeMode="fit"
        [stateStorage]="'local'"
        [stateKey]="summaryStateKey"
        [scrollable]="false"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn>{{ 'reports.fill.summaryColumns.kbName' | translate }}</th>
            <th pResizableColumn>{{ 'reports.fill.summaryColumns.chargingSystem' | translate }}</th>
            <th pResizableColumn>{{ 'reports.fill.summaryColumns.emission' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.kbName ?? '—' }}</td>
            <td>{{ row.chargingSystemName ?? '—' }}</td>
            <td>{{ row.totalEmission ?? 0 | number: '1.0-8' }} {{ 'reports.fill.unitKg' | translate }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">{{ 'reports.fill.summaryEmpty' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div class="summary-total px-4 py-3 text-sm font-semibold">
        {{ 'reports.fill.totalEmissionLabel' | translate }}:
        {{ totalEmission | number: '1.0-8' }}
        {{ 'reports.fill.unitKg' | translate }}
      </div>
    </div>
  }
</div>
